import React from 'react'
import Grid from '@mui/material/Grid'
import  Typography from '@mui/material/Typography'
import Backbutton from '../buttons/backbutton/backbutton'
interface iProps {title:string,backbutton_path:string}
export default function Title({title,backbutton_path}:iProps) {
  return (
    <Grid container marginY={'5px'} size={12} position="relative">
        <Grid   container size={12} justifyContent={'center'}>
            <Typography sx={{color:'var(--primary-color)',fontSize:'1.6rem'}}>
                {title}
            </Typography>
             <Backbutton previousPageRoute={backbutton_path??''} />
        </Grid>
    </Grid>
  )
}


